import type { SVGProps } from "react";
const SvgDeutscheBankLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" {...props}>
    <path
      d="M1 1h148v148H1zm21 21v107h107V22zm68 15h27l-56 77H34z"
      style={{
        fill: "#0018a8",
        fillRule: "evenodd",
      }}
    />
  </svg>
);
export default SvgDeutscheBankLogo;
